// extracted by mini-css-extract-plugin
module.exports = {"main":"Tabs_main__20ILa","tab":"Tabs_tab__28Mkm","apr":"Tabs_apr__319xu","selected":"Tabs_selected__r_pj1"};